import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import AppsIcon from '@mui/icons-material/Apps';
import { useNavigate } from 'react-router-dom';
import { useRolePreview } from '../context/RolePreviewContext';

const RolePreviewBanner = () => {
  const { previewRole, exitPreview } = useRolePreview();
  const navigate = useNavigate();

  if (!previewRole) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        bgcolor: '#7c3aed',
        color: '#fff',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <VisibilityIcon fontSize="small" />
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          Forhåndsvisning som:
        </Typography>
        <Chip
          label={previewRole.label}
          size="small"
          sx={{
            bgcolor: previewRole.color || '#a78bfa',
            color: '#fff',
            fontWeight: 700,
            fontSize: '0.75rem',
          }}
        />
        <Typography variant="caption" sx={{ opacity: 0.8 }}>
          {(previewRole.permissions || []).length} permissions
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1} alignItems="center">
        <Button
          size="small"
          variant="outlined"
          startIcon={<AdminPanelSettingsIcon />}
          onClick={() => navigate('/dashboard/admin/dashboard')}
          sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.5)', fontSize: '0.75rem' }}
        >
          Admin
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={<AppsIcon />}
          onClick={() => navigate('/app/dashboard')}
          sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.5)', fontSize: '0.75rem' }}
        >
          App
        </Button>
        <Button
          size="small"
          variant="contained"
          startIcon={<CloseIcon />}
          onClick={exitPreview}
          sx={{ bgcolor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }, fontSize: '0.75rem' }}
        >
          Avslutt preview
        </Button>
      </Stack>
    </Box>
  );
};

export default RolePreviewBanner;
